import React from 'react';
import axios from 'axios';
import axiosConfig from '../config/axios.config'
const LogHandlerContext = React.createContext();
const LogHandlerDispatchContext = React.createContext();

const dispatchReducer = (state, action) => {
    // console.log('LogHandlerContext --> ' + action.type)
    switch(action.type) {
        case 'error_log':
            const body = {
                error: action.error,
                history: action.history,
                client: action.client
            }
            axios.post(`${axiosConfig.localUrl}/backend/post-error`, body).then(res => {
                console.log(res)
            }).catch(err => console.log(err))

            state.errors.push(body)
            return state;
        case 'activity_log':
            state.activity = {
                ...state.activity,
                user: action.body && action.body.user && action.body.user.email ? action.body.user : false,
                log: {
                    _id: action.body && action.body._id,
                    timestamp: action.body && action.body.timestamp
                },
                instance: action.body.instance
            }
            axios.post(`${axiosConfig.localUrl}/backend/post-activity`, state.activity).then(res => {
                console.log(res)
            }).catch(err => console.log(err))

            return state;
        default: return state;
    }
}

const LogHandlerContextProvider = props => {
    const [state, dispatch] = React.useReducer(dispatchReducer, {
        errors: [],
        activity: {
            log: {},
            user:false,
            instance: 'STANFORD' // will update the value of instance on activity_log action
        }
    })

    const dispatchPayload = React.useMemo(() => ({updateLogHandler: dispatch}), [dispatch]);

    return(
        <LogHandlerContext.Provider value={state}>
            <LogHandlerDispatchContext.Provider value={dispatchPayload}>
                {props.children}
            </LogHandlerDispatchContext.Provider>
        </LogHandlerContext.Provider>
    )
}

const useLogHandler = () => {
    const context = React.useContext(LogHandlerContext);
    if (context === undefined) {throw new Error('LogHandlerContext must be used within LogHandlerContextProvider')}
    return context;
}
const useLogHandlerDispatch = () => {
    const context = React.useContext(LogHandlerDispatchContext);
    if (context === undefined) {throw new Error('LogHandlerContext must be used within LogHandlerContextProvider')}
    return context;
}

export {LogHandlerContextProvider, useLogHandler, useLogHandlerDispatch};
